// TODO: #187173840 remove beta switching code when removing old simulator
import createModule from "../createModule"
import view from "./view"
import { Creators as NotificationsCreators } from "modules/notifications/model"
import { Creators as DialogCreators } from "modules/dialog/model"
import { Creators as RebalanceCreators } from "modules/rebalance/model"
import { getDownloadData } from "modules/rebalance/selectors/download"
import { getNumberOfTrades } from "modules/rebalance/selectors/data"
import { getIsIntradayRebalance } from "modules/rebalance/selectors/intraday"
import { getHasData, getLastRefresh } from "modules/intraday/selectors"

export default createModule({
  externalProps: (state) => ({
    account: state.global.selected.account,
  }),
  required: ["account"],
  data: [],
  mapStateToProps: (state, props) => ({
    downloadData: getDownloadData(state, props),
    numberOfTrades: getNumberOfTrades(state, props),
    rebalanceIsIntraday: getIsIntradayRebalance(state),
    hasData: getHasData(state, props),
    lastRefresh: getLastRefresh(state, props),
  }),
  view,
  actions: {
    openDialog: DialogCreators.open,
    closeDialog: DialogCreators.close,
    addNotification: NotificationsCreators.add,
    reloadIntraday: RebalanceCreators.reloadIntraday,
    resetRebalance: RebalanceCreators.resetRebalance,
  },
})
